const cursorMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

let cursor = null;
let dot = null;
let ring = null;
let label = null;
let rafId = null;
let isReady = false;
let isVisible = false;

const pointer = { x: 0, y: 0 };
const ringPosition = { x: 0, y: 0 };

const interactiveSelector = [
    'a',
    'button',
    'input',
    'textarea',
    'select',
    '[role="button"]',
    '.js-cut-frame',
    '.splide__arrow',
    '.accordion',
    '.fancy-btn',
    '.ui-btn',
].join(',');

const canUseCursor = () => cursorMedia.matches && !reduceMotion.matches;

const createCursor = () => {
    cursor = document.createElement('div');
    cursor.className = 'atey-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    cursor.innerHTML = `
        <span class="atey-cursor__ring"></span>
        <span class="atey-cursor__dot"></span>
        <span class="atey-cursor__label"></span>
    `;

    document.body.appendChild(cursor);

    ring = cursor.querySelector('.atey-cursor__ring');
    dot = cursor.querySelector('.atey-cursor__dot');
    label = cursor.querySelector('.atey-cursor__label');
};

const moveCursor = () => {
    if (!cursor || !dot || !ring || !label) {
        rafId = null;
        return;
    }

    ringPosition.x += (pointer.x - ringPosition.x) * 0.18;
    ringPosition.y += (pointer.y - ringPosition.y) * 0.18;

    dot.style.transform = `translate3d(${pointer.x}px, ${pointer.y}px, 0) translate(-50%, -50%)`;
    ring.style.transform = `translate3d(${ringPosition.x}px, ${ringPosition.y}px, 0) translate(-50%, -50%)`;
    label.style.transform = `translate3d(${ringPosition.x}px, ${ringPosition.y}px, 0) translate(-50%, calc(-50% - 2px))`;

    rafId = window.requestAnimationFrame(moveCursor);
};

const showCursor = () => {
    if (!cursor) {
        return;
    }

    if (isVisible) {
        return;
    }

    isVisible = true;
    document.body.classList.add('has-custom-cursor');
};

const hideCursor = () => {
    isVisible = false;
    document.body.classList.remove('has-custom-cursor', 'is-cursor-active', 'is-cursor-pressed', 'is-cursor-labeled');

    if (label) {
        label.textContent = '';
    }
};

const onPointerMove = event => {
    if (!cursor) {
        return;
    }

    pointer.x = event.clientX;
    pointer.y = event.clientY;

    if (!isReady) {
        ringPosition.x = pointer.x;
        ringPosition.y = pointer.y;
        isReady = true;
    }

    showCursor();
};

const onPointerOver = event => {
    if (!label) {
        return;
    }

    const target = event.target.closest(interactiveSelector);

    if (!target) {
        return;
    }

    const cursorText = target.getAttribute('data-cursor-text');

    document.body.classList.add('is-cursor-active');

    if (cursorText) {
        label.textContent = cursorText;
        document.body.classList.add('is-cursor-labeled');
    }
};

const onPointerOut = event => {
    if (!label) {
        return;
    }

    const target = event.target.closest(interactiveSelector);

    if (!target) {
        return;
    }

    document.body.classList.remove('is-cursor-active', 'is-cursor-labeled');
    label.textContent = '';
};

const onPointerDown = () => {
    document.body.classList.add('is-cursor-pressed');
};

const onPointerUp = () => {
    document.body.classList.remove('is-cursor-pressed');
};

const destroyCursor = () => {
    if (!cursor) {
        isReady = false;
        isVisible = false;
        document.body.classList.remove('has-custom-cursor', 'is-cursor-active', 'is-cursor-pressed', 'is-cursor-labeled');
        return;
    }

    hideCursor();
    isReady = false;

    document.removeEventListener('pointermove', onPointerMove);
    document.removeEventListener('pointerover', onPointerOver);
    document.removeEventListener('pointerout', onPointerOut);
    document.removeEventListener('pointerdown', onPointerDown);
    document.removeEventListener('pointerup', onPointerUp);
    document.removeEventListener('mouseleave', hideCursor);

    if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
    }

    cursor?.remove();
    cursor = null;
    dot = null;
    ring = null;
    label = null;
};

const initCursor = () => {
    if (!cursorMedia.matches || reduceMotion.matches || cursor) {
        return;
    }

    createCursor();

    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerover', onPointerOver);
    document.addEventListener('pointerout', onPointerOut);
    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('pointerup', onPointerUp);
    document.addEventListener('mouseleave', hideCursor);

    rafId = window.requestAnimationFrame(moveCursor);
};

const syncCursor = () => {
    if (canUseCursor()) {
        initCursor();
        return;
    }

    if (cursor) {
        destroyCursor();
    }
};

syncCursor();

if (cursorMedia.addEventListener) {
    cursorMedia.addEventListener('change', syncCursor);
    reduceMotion.addEventListener('change', syncCursor);
} else {
    cursorMedia.addListener(syncCursor);
    reduceMotion.addListener(syncCursor);
}
